export const isEmpty = (value: any) =>
  value === undefined || value === null || value === '' || value.length === 0 || value.size === 0
